// extracted by mini-css-extract-plugin
export var modal = "_cg-0";